var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHobbies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M831 1841 c-11 -7 -3 -12 30 -21 76 -20 170 -77 279 -167 188 -155 359 -250 469 -260 l61 -6 0 -92 0 -93 -87 24 c-104 29 -373 85 -528 110 -149 24 -431 25 -528 1 -91 -23 -167 -62 -167 -86 0 -18 5 -17 58 10 188 97 559 80 1077 -47 163 -40 165 -41 165 -75 0 -17 -7 -61 -16 -100 -15 -65 -17 -69 -37 -62 -12 4 -56 8 -97 7 -83 -1 -112 -10 -475 -144 -230 -86 -320 -108 -468 -117 -64 -4 -96 -10 -94 -17 6 -17 201 -12 292 9 43 9 178 55 300 100 357 134 443 156 527 132 l27 -7 -16 -45 c-8 -25 -18 -43 -23 -40 -4 2 -16 -5 -26 -18 l-19 -22 23 19 c30 26 28 7 -9 -67 -88 -174 -226 -311 -393 -388 l-61 -28 40 0 c40 0 132 16 106 18 -8 0 12 18 45 39 138 89 264 249 330 417 15 39 30 74 35 79 19 22 86 -121 91 -194 2 -48 10 -50 30 -9 14 28 14 35 -4 81 -28 75 -53 120 -82 149 -25 25 -25 26 -11 80 8 30 15 68 15 86 0 62 5 64 73 35 34 -14 79 -36 100 -49 l37 -23 0 24 c0 21 -12 31 -75 61 -41 19 -79 35 -84 35 -6 0 -9 6 -7 13 1 6 1 9 -1 5 -3 -5 -10 -8 -16 -8 -9 0 -12 31 -12 105 l0 105 58 11 c62 13 80 31 53 55 -8 8 -13 11 -10 7 7 -9 -97 -43 -108 -36 -5 2 -8 13 -8 23 0 63 -91 246 -154 313 -22 22 -94 67 -109 67 -3 0 26 -31 63 -69 47 -47 80 -93 108 -149 40 -80 71 -186 59 -198 -14 -15 -127 18 -212 61 -83 41 -199 123 -351 248 -66 53 -188 117 -225 117 -13 0 -30 -4 -38 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727 1591 c3 -11 11 -22 19 -25 11 -4 11 0 -2 19 -20 30 -24 31 -17 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741 1534 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751 1474 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753 1330 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741 1244 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882 1225 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882 1025 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485 758 l-50 -53 53 50 c48 46 57 55 49 55 -1 0 -25 -24 -52 -52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806 783 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399 683 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709 633 l-24 -28 28 24 c15 14 27 26 27 28 0 8 -8 1 -31 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264 594 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 560 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5 0 -17 -5 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1609 533 l-24 -28 28 24 c15 14 27 26 27 28 0 8 -8 1 -31 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705 491 c-3 -5 0 -13 6 -17 7 -4 9 -3 5 4 -3 6 3 12 16 15 23 4 23 4 1 6 -12 0 -24 -3 -28 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958 493 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 483 c17 -2 47 -2 65 0 17 2 3 4 -33 4 -36 0 -50 -2 -32 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 459 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500 460 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777 439 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 440 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420 420 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018 363 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobbies);
export default __webpack_public_path__ + "static/media/hobbies.5c0aed1daead431cc84906547498cc9a.svg";
export { ForwardRef as ReactComponent };